














import { Component, Prop, Vue } from 'vue-property-decorator';
import { HOST } from '@/global';
import {
  TimelineMax,
  CSSPlugin,
  CSSRulePlugin,
  ScrollToPlugin,
  Draggable,
  Power4,
  Expo,
  Elastic,
  Bounce,
  onComplete,
  clearProps,
  TweenMax,
  fromTo
} from 'gsap/all';

import ScrollMagic from 'scrollmagic';
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';

@Component({
  name: 'mission'
})
export default class Mission extends Vue {
  // @Prop() private msg!: string;
  @Prop() compData: any;
  HOST: string = HOST;
}
